import React, { memo, useCallback, useMemo } from 'react';
import Modal from 'utils/packages/Modal';
import { useAppSelector } from 'store/hooks';
import { Tier } from 'features/premium/entities';
import { selectUserTier } from 'features/premium/selectors/tier';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { UpgradeWebModal } from 'design-system/UpgradeWebModal';
import { isWeb } from '../../../constants';
import RowAmount from './RowAmount';
import FxFeeEstSubTitle from './FxFeeEstSubTitle';
const FxFeeRow = ({ fxConversion, tableSpacing }) => {
    const navigation = useMainStackNavigation();
    const userTier = useAppSelector(selectUserTier);
    const amount = useMemo(() => ({
        value: fxConversion.fee.value,
        currency: fxConversion.fee.currency,
    }), [fxConversion.fee.currency, fxConversion.fee.value]);
    const openEmmaProModal = useCallback(() => {
        Modal.hide(() => {
            if (isWeb) {
                UpgradeWebModal.show(undefined);
                return;
            }
            navigation.navigateDeprecated('EmmaProModal', { benefitId: 'fxFees' });
        });
    }, []);
    return (<RowAmount est showCents noBottomLine title="FX fee" amount={amount} testID="rowFXFee" noPaddingHorizontal tooltipTitle="FX fee" tableSpacing={tableSpacing} tootTipBtnText="Okay, thanks" tooltipText={<FxFeeEstSubTitle fxConversion={fxConversion}/>} toolTipOnExtraBtnPress={openEmmaProModal} toolTipExtraBtnText={userTier === Tier.ultimate ? undefined : 'View all plans'}/>);
};
export default memo(FxFeeRow);
